module.exports = __webpack_public_path__ + "static/img/关于我们配图-03.23798d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们配图-03.jpg
// module id = dMEy
// module chunks = 1